/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_LeadInputs */



/**
* | output |
* | --- |
* | "Transparency, compliance and governance documents for AWP Marine Consultancy." |
*
* @param {Legal_LeadInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const legal_lead = /** @type {((inputs?: Legal_LeadInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_LeadInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("AWP Marine Consultancy 的透明度、合规和治理文件。")
	return /** @type {LocalizedString} */ ("Transparency, compliance and governance documents for AWP Marine Consultancy.")
});